import { useReducer } from "react";

type UseRefreshResult = [
    number,
    () => void
];

const useRefresh: () => UseRefreshResult = () => {
    const [ refreshIndex, refresh ] = useReducer((v: number) => v + 1, 0);

    return [
        refreshIndex,
        refresh
    ];
};

export default useRefresh;